import React, { useId, useMemo, useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

export default function SectionCard({
  title,
  subtitle,
  open,
  defaultOpen = true,
  onToggle,
  right,
  children,
  disabled = false,
  className = "",
  bodyClassName = "",
}) {
  const autoId = useId();
  const bodyId = useMemo(() => `sectioncard-body-${autoId}`, [autoId]);

  const isControlled = typeof open === "boolean";
  const [innerOpen, setInnerOpen] = useState(Boolean(defaultOpen));
  const isOpen = isControlled ? open : innerOpen;

  const toggle = () => {
    if (disabled) return;
    const next = !isOpen;

    if (!isControlled) setInnerOpen(next);
    onToggle?.(next);
  };

  return (
    <div className={`cf-card ${className}`.trim()}>
      <button
        type="button"
        className="cf-card-head"
        onClick={toggle}
        disabled={disabled}
        aria-expanded={Boolean(isOpen)}
        aria-controls={bodyId}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <div className="cf-card-title">{title}</div>

          {subtitle ? (
            <div style={{ fontSize: 12, color: "#6b7280", fontWeight: 400 }}>
              {subtitle}
            </div>
          ) : null}
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {right ? (
            <div onClick={(e) => e.stopPropagation()}>{right}</div>
          ) : null}
          {isOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
        </div>
      </button>

      {isOpen ? (
        <div id={bodyId} className={`cf-card-body ${bodyClassName}`.trim()}>
          {children}
        </div>
      ) : null}
    </div>
  );
}
